import React, { memo } from 'react'

const SIZE_CONFIG = {
  s: 'w-8 h-8 text-xs',
  m: 'w-8 h-8 text-xs',
  l: 'w-10 h-10 text-sm',
}

const Avatar = ({
  className,
  user: { photo, online, name },
  size = 'm',
  showStatus = true,
  theme = 'bg-blue-700',
}) => {
  return (
    <div className={`relative ${className}`}>
      <div
        className={`${online || !showStatus ? 'opacity-100' : 'opacity-50'}`}
      >
        {photo ? (
          <img
            className={SIZE_CONFIG[size]}
            style={{
              borderRadius: '50%',
              transform: size === 's' ? 'scale(0.75)' : 'none',
            }}
            src={photo}
            alt="用户头像"
          />
        ) : (
          <div
            className={`${theme} ${SIZE_CONFIG[size]} text-white flex justify-center items-center rounded-full`}
            style={{ transform: size === 's' ? 'scale(0.75)' : 'none' }}
          >
            {name.slice(-2)}
          </div>
        )}
      </div>
      {showStatus && (
        <div
          className={`absolute w-2.5 h-2.5 rounded-full ${
            online ? 'bg-green-500' : 'bg-gray-400'
          } top-0 left-0`}
        />
      )}
    </div>
  )
}

export default memo(Avatar)
